import React, { Component } from 'react';
import { ScrollView, View, StyleSheet } from 'react-native';
import DRNText from '../../standard/Text/DRNText';
import { withTheme } from '../../theme';
import PropTypes from 'prop-types';
import { getFlatlistFormat } from './util';
import R from '../../core-res/R';
class HolidayList extends Component {
    constructor(props) {
        super(props);
        this.getEventText = itemArray => {
            if (itemArray.length === 1)
                return itemArray[0];
            return itemArray.join(', ');
        };
        this.data = getFlatlistFormat(props.holidayList);
    }
    render() {
        const { theme } = this.props;
        return (<View style={styles.container}>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          {this.data.map((item, index) => (<View key={index} style={[styles.item, { borderColor: theme.lightNeutral }]}>
              <DRNText style={[styles.date, { color: theme.textAlert }]}>{item.key}</DRNText>
              <DRNText style={styles.event}>{this.getEventText(item.value)}</DRNText>
            </View>))}
        </ScrollView>
      </View>);
    }
}
HolidayList.propTypes = {
    holidayList: PropTypes.object.isRequired,
    theme: PropTypes.object,
};
const styles = StyleSheet.create({
    container: {
        height: 28,
    },
    item: {
        flexDirection: 'row',
        padding: R.spacing.xxs,
        borderWidth: R.border.width.thin,
        borderRadius: R.border.radius.default,
        marginLeft: R.spacing.s,
    },
    date: Object.assign({}, R.typography.uiSmall, { marginRight: R.spacing.xs }),
    event: Object.assign({}, R.typography.uiSmall),
});
const DRNHolidayList = withTheme(HolidayList);
export default DRNHolidayList;
